import { createSelector } from "reselect";
const getConfigInfo = (state) => state && state.config;
export const getInstrumentDetailUrl = createSelector(
    [getConfigInfo],
    (configInfo) =>
        configInfo && configInfo.client && configInfo.client.flowApiUrl
            ? `${configInfo.client.flowApiUrl}api/instruments/`
            : '',
);